import { lazy } from 'react';

const GoodsAudit = lazy(() => import('pages/goodsAudit'));

const GoodsAuditDetail = lazy(() => import('pages/goodsAuditDetail'));

const GoodsManage = lazy(() => import('pages/goodsManage'));

const goodsManageDetail = lazy(() => import('pages/goodsManageDetail'));
const SuningGoods = lazy(() => import('pages/suningGoods'));
const DoudianGoods = lazy(() => import('pages/doudianGoods'));

const kuaiTTGoodsList = lazy(() => import('pages/kuaiTTGoodsList'));
const kuaiTTGoodsDetail = lazy(() => import('pages/kuaiTTGoodsDetail'));

export const router = {
    path: '/goods',
    name: '商品管理',
    permission: 103,
    icon: 'book',
    children: [
        {
            path: 'goodsAudit',
            name: '商品审核',
            icon: 'book',
            permission: 10301,
            component: GoodsAudit,
        },
        {
            path: 'goodsManage',
            name: '商品管理',
            icon: 'book',
            permission: 10302,
            component: GoodsManage,
        },
        {
            path: 'goodsAuditDetail',
            name: '商品审核详情',
            hideInMenu: true,
            icon: 'bok',
            permission: 10301,
            component: GoodsAuditDetail,
        },
        {
            path: 'goodsManageDetail',
            name: '商品管理详情',
            hideInMenu: true,
            icon: 'book',
            permission: 10302,
            component: goodsManageDetail,
        },
        {
            path: 'suningGoods',
            name: '苏宁有货',
            icon: 'book',
            permission: 10303,
            component: SuningGoods,
        },
        {
            path: 'doudianGoods',
            name: '抖店商品',
            icon: 'book',
            permission: 10304,
            component: DoudianGoods,
        },
        {
            path: 'kuaiTTGoodsList',
            name: '快团团团购管理',
            icon: 'book',
            permission: 10305,
            component: kuaiTTGoodsList,
        },
        {
            path: 'kuaiTTGoodsDetail',
            name: '快团团团购详情',
            hideInMenu: true,
            icon: 'book',
            permission: 10305,
            component: kuaiTTGoodsDetail,
        },
    ],
};

export default router;
